import React from 'react'
import classNames from 'classnames'

import styles from './styles.module.scss'

import type { PriceDifferenceProps } from './types'

export const PriceDifference: React.FC<PriceDifferenceProps> = ({ priceDifference }) => {
  const className = classNames({
    [styles.priceDifferenceRender_success]: priceDifference < 0,
    [styles.priceDifferenceRender_danger]: priceDifference > 0
  })

  return <span className={ className }>{ priceDifference }%</span>
}
